import type { ComponentProps } from 'react'
import { FiltersPanel } from '@/features/reservation/components/PropertyFilters'

export function HorizonFilterPanel(props: ComponentProps<typeof FiltersPanel>) {
  return (
    <div className="rounded-[var(--brand-radius-lg)] border border-[var(--brand-border-soft)] bg-[var(--brand-surface)] p-4 shadow-[var(--brand-shadow-1)]">
      <FiltersPanel {...props} />
    </div>
  )
}
